export default "__VITE_ASSET__E194O$6i__"